var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.3335V4.3335C16 6.21883 16 7.1615 16.5867 7.74683C17.1707 8.3335 18.1133 8.3335 20 8.3335H22",
    stroke: "#006600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 20.3334V9.66675C1.33325 5.89608 1.33325 4.00941 2.50525 2.83875C3.67592 1.66675 5.56259 1.66675 9.33325 1.66675H14.8959C15.4399 1.66675 15.7133 1.66675 15.9586 1.76808C16.2026 1.86941 16.3959 2.06141 16.7813 2.44808L21.8853 7.55208C22.2719 7.93875 22.4639 8.13075 22.5653 8.37608C22.6666 8.62008 22.6666 8.89341 22.6666 9.43741V20.3334C22.6666 24.1041 22.6666 25.9907 21.4946 27.1614C20.3239 28.3334 18.4373 28.3334 14.6666 28.3334H9.33325C5.56259 28.3334 3.67592 28.3334 2.50525 27.1614C1.33325 25.9907 1.33325 24.1041 1.33325 20.3334Z",
    stroke: "#006600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6667V17.6667M12 17.6667V21.6667M12 17.6667H6M12 17.6667H18M8.66667 21.6667H15.3333C16.5907 21.6667 17.2187 21.6667 17.6093 21.2761C18 20.8854 18 20.2574 18 19.0001V16.3334C18 15.0761 18 14.4481 17.6093 14.0574C17.2187 13.6667 16.5907 13.6667 15.3333 13.6667H8.66667C7.40933 13.6667 6.78133 13.6667 6.39067 14.0574C6 14.4481 6 15.0761 6 16.3334V19.0001C6 20.2574 6 20.8854 6.39067 21.2761C6.78133 21.6667 7.40933 21.6667 8.66667 21.6667Z",
    stroke: "#006600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/Sheet.5edabbbc030a92ebaaf422c6d15eb46b.svg";
export { ForwardRef as ReactComponent };